<template>
    <div class="mb-4 w-full rounded bg-gray-50">
        <div
            class="flex items-center justify-between rounded-t px-4 py-3 hover:cursor-pointer hover:bg-gray-200"
            @click="expanded = !expanded"
        >
            <div class="leading-2 py-4 pr-4 font-semibold text-gray-900">
                {{ question }}
            </div>
            <div v-if="!expanded" class="">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 5V19"
                        stroke="#A4B0B7"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M5 12H19"
                        stroke="#A4B0B7"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div v-else class="">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5 12H19"
                        stroke="#A4B0B7"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
        <div v-if="expanded" class="p-4 pt-2 text-gray-800">
            <span v-if="answer" v-html="answer"></span>
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "ExpandingTextBlock",
    props: {
        question: {
            type: String,
            default: "",
        },
        answer: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            expanded: false,
        };
    },
};
</script>

<style scoped>
p {
    margin-bottom: 1rem;
}
</style>
